import { GridCellProps } from "@progress/kendo-react-grid";
import BooleanToTextCell from "./BooleanToTextCell";

export default function BooleanAsYesNoCell(props: GridCellProps) {
  return (
    <BooleanToTextCell {...props} trueTranslation="Yes" falseTranslation="No" />
  );
}
